import { usePOS } from '../context/POSContext';

function Receipt({ bill, showActions = true }) {
  const { completeOrder } = usePOS();

  // Si aucune facture n'est disponible
  if (!bill) {
    return (
      <div className="bg-white p-4 rounded-md shadow-sm">
        <p className="text-gray-500 text-center">Aucune facture à afficher.</p>
      </div>
    );
  }

const formatDateTime = (date) => {
  return new Date(date).toLocaleString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false, // 24H format
  });
};

  return (
    <>
      <style>
        {`
          @media print {
            body * {
              visibility: hidden;
            }
            .printable-receipt-container, .printable-receipt-container * {
              visibility: visible;
            }
            .printable-receipt-container {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              padding: 20px;
              font-size: 12pt;
            }
            .print-hidden {
              display: none !important;
            }
            .bg-white {
              background: white !important;
              border: 1px solid #000 !important;
              box-shadow: none !important;
            }
            .border-dashed {
              border-style: dashed !important;
            }
            .text-center {
              text-align: center !important;
            }
            .flex {
              display: flex !important;
            }
            .justify-between {
              justify-content: space-between !important;
            }
            .mb-4 {
              margin-bottom: 1rem !important;
            }
            .py-3 {
              padding-top: 0.75rem !important;
              padding-bottom: 0.75rem !important;
            }
            .text-sm {
              font-size: 10pt !important;
            }
            .font-bold {
              font-weight: bold !important;
            }
            .w-10 {
              width: 40px !important;
            }
            .w-16 {
              width: 64px !important;
            }
          }
        `}
      </style>
      <div className="bg-white p-4 rounded-md shadow-sm printable-receipt">
        <div className="border-b border-dashed border-gray-300 pb-4 mb-4">
          <h2 className="text-center font-bold text-xl mb-1">Snack SpongeBob</h2>
          <p className="text-center font-bold text-sm mb-1">Tel:+212 633-399393</p>
          <p className="text-center font-bold text-sm">
            {bill.createdAt ? formatDateTime(bill.createdAt) : 'Date inconnue'}
          </p>
        </div>

        <div className="mb-4">
          <div className="flex justify-between text-sm mb-1">
          
          </div>
          <div className="flex justify-between font-bold text-sm mb-1">
            <span>Table:</span>
            <span>{bill.order?.table?.tableNumber || 'À emporter'}</span>
          </div>
          {/* <div className="flex justify-between text-sm">
            <span>Status:</span>
            <span className={bill.order?.status === 'SERVED' ? 'text-green-600' : 'text-amber-600'}>
              {bill.order?.status?.charAt(0).toUpperCase() + bill.order?.status?.slice(1).toLowerCase()}
            </span>
          </div> */}
        </div>

        <div className="border-t border-b border-gray-300 py-3 mb-3">
          <div className="flex justify-between font-bold text-sm mb-2">
            <span>Produit </span>
            <div className="flex">
              <span className="w-10 text-center">Quantité</span>
              <span className="w-16 text-right">Prix</span>
            </div>
          </div>

          {(bill.order?.orderItem || []).map((item, index) => (
            <div key={index} className="flex justify-between font-bold text-sm mb-2">
              <span className="flex-1">{item.menuItem.name}</span>
              <div className="flex ">
                <span className="w-10 text-center">{item.quantity}</span>
                <span className="w-16 text-right">
                  {(item.menuItem.price * item.quantity).toFixed(2)}(MAD)
                </span>
              </div>
            </div>
          ))}
        </div>

        <div className="mb-4 font-bold">
          <div className="flex justify-between text-sm mb-1">
            <span>Sous-total:</span>
            <span>{bill.totalAmount?.toFixed(2) || '0.00'}(MAD)</span>
          </div>
          <div className="flex justify-between text-sm mb-1">
            <span>Remise :</span>
            <span>{bill.discount?.toFixed(2) || '0.00'}(MAD)</span>
          </div>
          <div className="flex justify-between text-sm mb-1">
            <span>Tax:</span>
            <span>{bill.tax?.toFixed(2) || '0.00'}(MAD)</span>
          </div>
          <div className="flex justify-between text-xl font-bold">
            <span>Total:</span>
            <span>{bill.finalAmmount?.toFixed(2) || '0.00'}(MAD)</span>
          </div>
        </div>
      </div>
    </>
  );
}

export default Receipt;